import React, { useState, useEffect } from "react";
import "../css/CountDownPage.css";

const CountdownPage = () => {
  const [showContent, setShowContent] = useState(true);
  const [countdown, setCountdown] = useState(5);
  const targetTime = new Date("2025-02-26T14:04:00"); // Set your specific time here

  useEffect(() => {
    const interval = setInterval(() => {
      const currentTime = new Date();
      const timeDifference = targetTime - currentTime;

      if (timeDifference <= 300000 && timeDifference > 5000) {
        // 5 minutes to 5 seconds
        setShowContent(true);
      } else if (timeDifference <= 5000 && timeDifference > 0) {
        // Last 5 seconds
        setShowContent(false);
        setCountdown(Math.ceil(timeDifference / 1000)); // Update countdown every second
      } else if (timeDifference <= 0) {
        // Redirect after countdown
        window.location.href = "https://example.com"; // Set your redirect URL here
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [targetTime]);

  return (
    <div className="page-container">
      {showContent ? (
        <div className="content">
          <h1>Welcome to the Special Event</h1>
          <p>
            This content will be available until 5 seconds before the event
            starts.
          </p>
        </div>
      ) : (
        <div className="countdown">
          <h1>{countdown}</h1>
        </div>
      )}
    </div>
  );
};

export default CountdownPage;
